import {Colors, Fonts} from '../../theme';
import React from 'react';
import { textStyles } from '../../theme/fonts-ppv';

export default {
  buttonDefault: {
    ...Fonts.style.textMessage,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white
  },
  buttonCancel: {
    border: 1,
    borderColor: Colors.scbPurple,
    borderStyle: 'solid',
    height: '40px',
    color: Colors.scbPurple,
    background: 'transparent',
  },
  buttonSubmit: {
    border: 1,
    borderColor: Colors.scbPurple,
    borderStyle: 'solid',
    height: '40px',
  },
  buttonModal: {
    backgroundColor: 'transparent',
    color: Colors.scbPurple,
    padding: '8px 0',
    margin: '0',
    borderRadius: '10px',
  },
  buttonRedStyle: {
    backgroundColor: Colors.cherryRed
  },
  buttonRegister: {
    ...Fonts.style.textMessage,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white,
  },
  buttonAdd: {
    ...textStyles.subtitle2,
    color: Colors.lightPurple,
    borderColor: Colors.lightPurple,
    borderRadius: '4px',
    background: 'transparent',
    height: '40px'
  },
  buttonCenter: {
    textAlign: 'center'
  } as React.CSSProperties,
  buttonGradient: {
    ...textStyles.subtitle2,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white,
    borderRadius: '4px',
    border: 'none',
    height: '40px'
  },
  buttonModalConfirmGradient: {
    ...textStyles.subtitle2,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white,
    borderColor: Colors.violet600,
    height: '40px',
    width: '114px',
    borderRadius: 5
  },
  buttonModalConfirmGradientDisable: {
    ...textStyles.subtitle2,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white,
    borderColor: Colors.violet600,
    height: '40px',
    width: '114px',
    opacity: 0.4,
    borderRadius: 5
  },
  buttonModalCancelGradient: {
    ...textStyles.subtitle2,
    background: 'transparent',
    borderColor: Colors.violet600,
    height: '40px',
    width: '114px',
    color: Colors.violet600,
    borderRadius: 5
  },
  buttonModalCancel: {
    ...textStyles.subtitle2,
    backgroundColor: Colors.white,
    borderRadius: 48,
    width: '105px',
    height: '44px',
    fontWeight: 700,
    fontSize: '16px'
  },
  buttonSave: {
    ...textStyles.subtitle2,
    color: Colors.white,
    backgroundColor: Colors.violet600,
    borderColor: Colors.violet600,
    borderRadius: 48,
    width: '105px',
    height: '44px',
    fontWeight: 700,
    fontSize: '16px'

  },
  buttonFromConfirmGradient: {
     ...textStyles.subtitle2,
    background: 'linear-gradient(122.09deg, #638AF2 -2.8%, #8828F5 54.25%, #530A8E 101.29%)',
    color: Colors.white,
    borderColor: Colors.violet600,
    height: '40px',
    width: '114px',
    borderRadius: 5
  },
  buttonFromCancelGradient: {
   ...textStyles.subtitle2,
    background: 'transparent',
    borderColor: Colors.violet600,
    height: '40px',
    width: '114px',
    color: Colors.violet600,
    borderRadius: 5
  },
  buttonAddMenuDiscount: {
    border: 1,
    borderColor: Colors.violet600,
    borderStyle: 'solid',
    height: '40px',
    color: Colors.violet600,
    background: 'transparent',
    borderRadius: '40px',
  },
  disabled: {
    opacity: '40%'
  }
};
